module.exports = __webpack_public_path__ + "static/media/Icons_Github_white.c5c1605a.svg";